var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M7.27 13.4h33.45a1.3 1.3 0 1 0 0-2.6H7.27a1.3 1.3 0 1 0 0 2.6m33.45 9.28H7.27a1.3 1.3 0 1 0 0 2.6h33.45a1.3 1.3 0 1 0 0-2.6m0 12H7.27a1.3 1.3 0 1 0 0 2.6h33.45a1.3 1.3 0 1 0 0-2.6",
  clipRule: "evenodd"
})));
export { SvgMenu as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/menu.svg", import.meta.url).toString();